<template>
  <div
    class="Popover"
    v-show="isPopover"
  >
    <div
      @click="iconGuanbihander()"
      class="Popover_mask"
    ></div>
    <div class="Popover_content">
      <div
        v-if="title"
        class="Popover_content_header"
      >
        <slot name="title">{{title}}</slot>
        <i
          @click="iconGuanbihander()"
          class="iconfont icon-guanbi icon_guanbi"
        ></i>
      </div>
      <div class="contentBox">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Popover',
  props: {
    isPopover: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    iconGuanbihander() {
      this.$emit('close', false);
    },
  },
};
</script>
<style scoped>
.Popover {
  position: fixed;
  top: 0;
  z-index: 9;
  left: 0;
  width: 100%;
  height: 100%;
}
.Popover_content {
  width: 100%;
  height: 88%;
  background: #fff;
  position: fixed;
  left: 0;
  bottom: 0px;
  z-index: 3;
  border-radius: 8px 8px 0 0;
  transform: translateY(100%);
  animation: a 0.1s linear forwards;
  backface-visibility: hidden;
  transition: transform 0.1s;
  display: flex;
  flex-direction: column;
}
.Popover_mask {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  left: 0;
  bottom: 0px;
  z-index: 2;
  background: rgba(0, 0, 0, 0.31);
}
.Popover_content_header {
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 14px 0 16px;
  border-radius: 8px 8px 0 0;
  border-bottom: 1px solid #e9f0f5;
  flex: 0 0 50px;
}
.Popover_content_header_text {
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #1c2438;
}
.icon_guanbi {
  color: #80848f;
  font-size: 27px;
}
@keyframes a {
  0% {
    transform: translate3d(0, 100%, 0);
  }
  100% {
    transform: translateZ(0);
  }
}
.contentBox {
  width: 100%;
  flex: 1;
  overflow: auto;
}
</style>
